export default "__VITE_ASSET__BAUY_X0Z__"